import Item from './item'

export default class AddItem extends Item {
  constructor (game, stack) {
    super(game, stack, 'item_add')

    this.instructionName = 'ADD'
    this.operands = ['A', 'B']
  }

  _activate () {
    const opA = this.stack.pop()
    const opB = this.stack.pop()
    this.stack.push((opA + opB) % 255)
  }
}
